import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UploadResult } from '@app/interfaces/lm/file';
import { environment } from '@env/environment';
import { lastValueFrom, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FileService {

    private moduleApi = environment.api.services.sys;

    private baseUrl = this.moduleApi + '/files';

    constructor(private http: HttpClient) {
    }

    upload(data: FormData): Observable<HttpEvent<UploadResult>> {
        return this.http.post<UploadResult>(`${this.baseUrl}`, data, {
            reportProgress: true,
            observe: 'events'
        });
    }

    uploadFile(data: FormData): Promise<UploadResult> {
        return lastValueFrom(this.http.post<UploadResult>(`${this.baseUrl}`, data));
    }

    getPath(path: string): string {
        return `${environment.api.baseUrl}${this.baseUrl}?path=${path}`;
    }

    download(path: string): void {
        const url = this.getPath(path);
        window.open(url);
    }

    async remove(params: { path: string }): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign(params)
        }));
    }
}
